import React from 'react';

import type { RouteMatch } from '@confluence/route';
import { SmartCreatePageEditorLoader } from '@confluence/smart-create-page-editor';
import { fg } from '@confluence/feature-gating';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection';
import { HOME } from '@confluence/named-routes';
import { ClassicEditorContextProviderLoader } from '@confluence-classic/confluence-fabric-editor/src/components/ClassicEditorContextProvider';

import { navdexEnd } from '../naxdev';

export const EditPageSmartCreateRoute = ({ params: { contentId, spaceKey } }: RouteMatch) => {
	if (!fg('aifc_create_enabled')) {
		return <Redirection href={HOME.toUrl()} />;
	}

	return (
		<ClassicEditorContextProviderLoader>
			<SmartCreatePageEditorLoader contentId={contentId} spaceKey={spaceKey} />
		</ClassicEditorContextProviderLoader>
	);
};

EditPageSmartCreateRoute.NAVIGATION_PARAMS = ({ params: { contentId, spaceKey } }: RouteMatch) => ({
	Screen: {
		showPremiumOnboarding: false,
		screenEvent: {
			name: 'editPageSmartCreateScreen',
			id: contentId,
			...navdexEnd,
		},
		pageState: { contentId, spaceKey, contentType: 'page' },
	},
	MainLayout: false,
	BannerContext: { includeTopNav: false },
});
